var _g, _g2, _g3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFree(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "free",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.883,
    height: 12.883,
    viewBox: "0 0 12.883 12.883",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104238",
    "data-name": "Group 104238",
    transform: "translate(9.32 2.753)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104237",
    "data-name": "Group 104237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64125",
    "data-name": "Path 64125",
    d: "M378.522,111.724a.4.4,0,1,0,0,.566h0a.4.4,0,0,0,0-.566Z",
    transform: "translate(-377.84 -111.607)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_104240",
    "data-name": "Group 104240",
    transform: "translate(4.605 6.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104239",
    "data-name": "Group 104239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64126",
    "data-name": "Path 64126",
    d: "M188.969,273.163a.366.366,0,0,0-.594-.01l-.322.322.6.6.322-.322a.366.366,0,0,0-.01-.594Z",
    transform: "translate(-188.053 -273.005)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_104242",
    "data-name": "Group 104242",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104241",
    "data-name": "Group 104241",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64127",
    "data-name": "Path 64127",
    d: "M12.864,4.973,12.25,1.578A1.178,1.178,0,0,0,11.3.632L7.91.019A1.173,1.173,0,0,0,6.872.343L.344,6.871a1.173,1.173,0,0,0,0,1.659l4.009,4.009a1.173,1.173,0,0,0,1.659,0l6.528-6.528A1.173,1.173,0,0,0,12.864,4.973ZM4.832,9.731a.407.407,0,0,1-.249.249.124.124,0,0,1-.132-.028L3.015,8.515A.127.127,0,0,1,2.98,8.39a.284.284,0,0,1,.08-.137l.785-.785a.123.123,0,0,1,.124-.034.286.286,0,0,1,.133.079.291.291,0,0,1,.083.139.124.124,0,0,1-.033.123l-.586.586.382.382L4.291,8.4a.127.127,0,0,1,.119-.037.235.235,0,0,1,.126.069.231.231,0,0,1,.066.12.126.126,0,0,1-.038.12l-.342.342L4.8,9.6A.124.124,0,0,1,4.832,9.731ZM6.755,7.774a.33.33,0,0,1-.092.209.166.166,0,0,1-.179.048l-.912-.292-.149.149.545.545A.124.124,0,0,1,6,8.566a.407.407,0,0,1-.249.249.124.124,0,0,1-.132-.028L4.177,7.348a.15.15,0,0,1,0-.215l.468-.468q.557-.557,1.041-.072a.621.621,0,0,1,.185.733l.776.224a.1.1,0,0,1,.052.029A.232.232,0,0,1,6.755,7.774Zm1.25-1.159L7.2,7.42a.284.284,0,0,1-.137.08.127.127,0,0,1-.126-.035L5.5,6.029A.127.127,0,0,1,5.466,5.9a.284.284,0,0,1,.08-.137l.805-.805a.123.123,0,0,1,.124-.034.286.286,0,0,1,.133.079.291.291,0,0,1,.083.139.124.124,0,0,1-.033.123l-.606.606.382.382.339-.339a.127.127,0,0,1,.119-.037.235.235,0,0,1,.126.069.231.231,0,0,1,.066.12.126.126,0,0,1-.038.12l-.339.339.385.385L7.7,6.307a.124.124,0,0,1,.123-.033.29.29,0,0,1,.139.083.287.287,0,0,1,.079.133A.123.123,0,0,1,8.005,6.615ZM9.225,5.4,8.419,6.2a.284.284,0,0,1-.137.08.127.127,0,0,1-.126-.035L6.72,4.809a.127.127,0,0,1-.035-.126.284.284,0,0,1,.08-.137l.805-.805A.123.123,0,0,1,7.7,3.708a.287.287,0,0,1,.133.079.291.291,0,0,1,.083.139.124.124,0,0,1-.033.123l-.606.606.382.382L7.994,4.7a.127.127,0,0,1,.119-.037.235.235,0,0,1,.126.069.231.231,0,0,1,.066.12.126.126,0,0,1-.038.12l-.339.339.385.385.606-.606a.124.124,0,0,1,.123-.033.321.321,0,0,1,.218.216A.123.123,0,0,1,9.225,5.4Zm1.292-1.577a1.034,1.034,0,1,1,.3-.731A1.031,1.031,0,0,1,10.517,3.818Z",
    transform: "translate(0 0)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/free.7cfb63725c9d08f6069884a77e3bff56.svg";
export { ForwardRef as ReactComponent };